import Fetch from '../fetch.js';
import {KjApi} from "../api";

export default function (param,accessToken) {

    let api =KjApi.getStudyDetail_ofv;
    let paramData = param;

    const promise = new Promise(function (resolve, reject) {

        Fetch(api, {
            data: paramData,
            headers:{"kj-film-view-token":accessToken},
            customError: true
        }).then(
            (data) =>{

                resolve(data);
            },
            (error)=>{
                console.log(error);
            }
        );
    });

    return promise;
}
